var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',{attrs:{"color":"secondary","prepend-icon":"opacity","value":_vm.layer.getOpacity(),"min":"0","max":"1","step":"0.01","thumb-label":"","hide-details":""},on:{"input":_vm.onOpacitySliderInput}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f9d4ceb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layerlist/LayerOpacityControl.vue
// module id = 3wTJ
// module chunks = 1